import { gql } from '@apollo/client';
import { CoreUser } from 'src/models/user/fragments';

export const appleAuth = gql`
  ${CoreUser}
  mutation appleAuth($identityToken: String!, $user: String!, $email: String, $fullName: String) {
    appleAuth(identityToken: $identityToken, user: $user, email: $email, fullName: $fullName) {
      ...CoreUser
    }
  }
`;

export const facebookAuth = gql`
  ${CoreUser}
  mutation facebookAuth(
    $accessToken: String!
    $email: String!
    $fullName: String!
    $avatar: String!
    $facebookId: String!
  ) {
    facebookAuth(
      accessToken: $accessToken
      email: $email
      fullName: $fullName
      avatar: $avatar
      facebookId: $facebookId
    ) {
      ...CoreUser
    }
  }
`;

export const signup = gql`
  ${CoreUser}
  mutation Signup($email: String!, $fullName: String!, $password: String!, $invitedCode: String) {
    signup(email: $email, fullName: $fullName, password: $password, invitedCode: $invitedCode) {
      ...CoreUser
    }
  }
`;

export const login = gql`
  ${CoreUser}
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      ...CoreUser
    }
  }
`;

export const logout = gql`
  ${CoreUser}
  mutation {
    logout {
      ...CoreUser
    }
  }
`;

export const addFriend = gql`
  mutation AddFriend($id: ID!) {
    addFriend(id: $id) {
      _id
      email
      friends
    }
  }
`;

export const removeFriend = gql`
  mutation RemoveFriend($id: ID!) {
    removeFriend(id: $id) {
      _id
      email
      friends
    }
  }
`;

export const forgotPassword = gql`
  mutation ForgotPassword($email: String!) {
    forgotPassword(email: $email) {
      _id
    }
  }
`;

export const updateProfile = gql`
  ${CoreUser}
  mutation UpdateProfile($avatar: String, $invitedCode: String, $enableChat: Boolean) {
    updateProfile(avatar: $avatar, invitedCode: $invitedCode, enableChat: $enableChat) {
      ...CoreUser
    }
  }
`;

export const updateUserProfile = gql`
  ${CoreUser}
  mutation UpdateUserProfile(
    $id: ID!
    $email: String
    $fullName: String
    $isISCH: Boolean
    $removeChatRequest: Boolean
  ) {
    updateUserProfile(
      id: $id
      email: $email
      fullName: $fullName
      isISCH: $isISCH
      removeChatRequest: $removeChatRequest
    ) {
      ...CoreUser
    }
  }
`;

export const updatePushToken = gql`
  mutation UpdatePushToken($token: String!) {
    updatePushToken(token: $token) {
      _id
      token
    }
  }
`;
